@import "../../globalStyles/commons";

:host {
  display: inline-block;
}

.badge {
  position: relative;
}

.badge-content {
  position: absolute;
  z-index: v(--z-index-badge);
  color: v(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--badge-color, v(--color-neutral));
  border-radius: 12px;
  padding: v(--spacing-01) var(--spacing-02);
  @include font-style(code-01);

  &.has-content {
    top: var(--badge-top, -0.5rem);
    right: var(--badge-left, -0.5rem);
    height: 1.25rem;
    min-width: 1.25rem;
  }

  &:not(.has-content) {
    top: var(--badge-top, -0.25rem);
    right: var(--badge-left, -0.25rem);
    height: 0.5rem;
    min-width: 0.5rem;
  }
}


@each $state in [success, warning, error] {
  .badge.color-#{$state} {
    .badge-content {
      background-color: var(--support-#{$state});
    }
  }
}
